import React, { useState, useEffect } from 'react';
import { getRuote, getSistemiDisponibili, generaSistemaRidotto, calcolaCostoSistemaRidotto, giocaSistemaRidotto, getSistemiSalvati, getSistemaDettaglio, deleteSistemaSalvato, verificaSistemaSalvato } from '../services/api';

const SistemiRidotti = () => {
  const [ruote, setRuote] = useState([]);
  const [sistemiDisponibili, setSistemiDisponibili] = useState([]);
  const [sistemiSalvati, setSistemiSalvati] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [activeTab, setActiveTab] = useState('nuovo');
  const [dettaglio, setDettaglio] = useState(null);
  
  const [numeriInput, setNumeriInput] = useState('');
  const [garanzia, setGaranzia] = useState('terno_se_4');
  const [selectedRuote, setSelectedRuote] = useState([]);
  const [importoPerColonna, setImportoPerColonna] = useState(1);
  const [dataGiocata, setDataGiocata] = useState(new Date().toISOString().split('T')[0]);
  
  const [sistemaGenerato, setSistemaGenerato] = useState(null);
  const [costoCalcolato, setCostoCalcolato] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [ruoteRes, sistemiRes, salvatiRes] = await Promise.all([
        getRuote(),
        getSistemiDisponibili(),
        getSistemiSalvati()
      ]);
      setRuote(ruoteRes.data);
      setSistemiDisponibili(sistemiRes.data);
      setSistemiSalvati(salvatiRes.data);
    } catch (err) {
      console.error('Errore:', err);
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (text, type = 'success') => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 5000);
  };

  const parseNumeri = () => {
    return numeriInput
      .split(',')
      .map(n => parseInt(n.trim()))
      .filter(n => n >= 1 && n <= 90);
  };

  const handleGeneraSistema = async () => {
    const numeri = parseNumeri();
    if (numeri.length < 7) {
      showMessage('Inserisci almeno 7 numeri diversi', 'error');
      return;
    }
    if (numeri.length > 10) {
      showMessage('Massimo 10 numeri', 'error');
      return;
    }
    try {
      const res = await generaSistemaRidotto({
        numeri,
        garanzia,
        tipo_giocata: 'terno'
      });
      setSistemaGenerato(res.data);
      if (selectedRuote.length > 0) {
        const costoRes = await calcolaCostoSistemaRidotto(
          numeri.length,
          garanzia,
          selectedRuote.length,
          importoPerColonna
        );
        setCostoCalcolato(costoRes.data);
      }
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore generazione', 'error');
    }
  };

  const handleCalcolaCosto = async () => {
    const numeri = parseNumeri();
    if (numeri.length < 7) {
      showMessage('Inserisci almeno 7 numeri', 'error');
      return;
    }
    if (selectedRuote.length === 0) {
      showMessage('Seleziona almeno una ruota', 'error');
      return;
    }
    try {
      const res = await calcolaCostoSistemaRidotto(
        numeri.length,
        garanzia,
        selectedRuote.length,
        importoPerColonna
      );
      setCostoCalcolato(res.data);
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore calcolo', 'error');
    }
  };

  const handleGiocaSistema = async () => {
    const numeri = parseNumeri();
    if (numeri.length < 7 || selectedRuote.length === 0) {
      showMessage('Completa i dati', 'error');
      return;
    }
    if (!window.confirm('Confermi la registrazione del sistema?')) return;
    try {
      const res = await giocaSistemaRidotto({
        numeri,
        garanzia,
        tipo_giocata: 'terno',
        ruote: selectedRuote,
        importo_per_colonna: importoPerColonna,
        data_giocata: dataGiocata
      });
      showMessage(res.data.message);
      setSistemaGenerato(null);
      setCostoCalcolato(null);
      setNumeriInput('');
      loadData();
      setActiveTab('salvati');
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore registrazione', 'error');
    }
  };

  const handleDettaglio = async (id) => {
    try {
      const res = await getSistemaDettaglio(id);
      setDettaglio(res.data);
    } catch (err) {
      showMessage('Errore caricamento dettaglio', 'error');
    }
  };

  const handleVerifica = async (id) => {
    try {
      const res = await verificaSistemaSalvato(id);
      setDettaglio(res.data);
      loadData();
      if (res.data.vincita_totale > 0) {
        showMessage('HAI VINTO EUR ' + res.data.vincita_totale.toFixed(2) + '!', 'success');
      } else {
        showMessage('Nessuna vincita', 'error');
      }
    } catch (err) {
      showMessage(err.response?.data?.detail || 'Errore verifica', 'error');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminare questo sistema?')) return;
    try {
      await deleteSistemaSalvato(id);
      showMessage('Sistema eliminato');
      loadData();
      setDettaglio(null);
    } catch (err) {
      showMessage('Errore eliminazione', 'error');
    }
  };

  const toggleRuota = (ruotaId) => {
    setSelectedRuote(prev => 
      prev.includes(ruotaId) ? prev.filter(r => r !== ruotaId) : [...prev, ruotaId]
    );
    setCostoCalcolato(null);
  };

  const selectAllRuote = () => {
    setSelectedRuote(selectedRuote.length === ruote.length ? [] : ruote.map(r => r.id));
    setCostoCalcolato(null);
  };

  const getStatoColor = (stato) => {
    switch(stato) {
      case 'vinto': return { bg: '#c6f6d5', color: '#22543d' };
      case 'perso': return { bg: '#fed7d7', color: '#822727' };
      default: return { bg: '#fef3c7', color: '#92400e' };
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div>
      <h2>Sistemi Ridotti</h2>
      <p style={{ color: '#718096', marginBottom: '20px' }}>
        Gioca piu numeri con meno colonne, con garanzia di vincita minima.
      </p>

      {message && (
        <div className={'alert alert-' + (message.type === 'error' ? 'error' : 'success')}>
          {message.text}
        </div>
      )}

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px' }}>
        <button className={activeTab === 'nuovo' ? 'btn btn-primary' : 'btn btn-secondary'} onClick={() => setActiveTab('nuovo')}>
          Nuovo Sistema
        </button>
        <button className={activeTab === 'salvati' ? 'btn btn-primary' : 'btn btn-secondary'} onClick={() => setActiveTab('salvati')}>
          I miei Sistemi ({sistemiSalvati.length})
        </button>
        <button className={activeTab === 'info' ? 'btn btn-primary' : 'btn btn-secondary'} onClick={() => setActiveTab('info')}>
          Info Sistemi
        </button>
      </div>

      {dettaglio && (
        <div className="card" style={{ marginBottom: '20px', border: '2px solid #2c5282' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <h3 className="card-title" style={{ margin: 0 }}>
              {dettaglio.nome || 'Dettaglio Sistema'}
            </h3>
            <button className="btn btn-secondary" onClick={() => setDettaglio(null)} style={{ padding: '5px 10px' }}>X</button>
          </div>
          
          <div style={{ marginBottom: '15px' }}>
            <strong>Numeri:</strong>
            <div style={{ display: 'flex', gap: '5px', marginTop: '5px', flexWrap: 'wrap' }}>
              {(dettaglio.numeri || dettaglio.numeri_sistema || []).map(n => (
                <span key={n} className="numero-ball">{n}</span>
              ))}
            </div>
          </div>

          {dettaglio.colonne && (
            <div style={{ marginBottom: '15px' }}>
              <strong>Colonne ({dettaglio.colonne.length}):</strong>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '8px', marginTop: '10px' }}>
                {dettaglio.colonne.map((col, idx) => (
                  <div key={idx} style={{ padding: '8px', background: '#f7fafc', borderRadius: '6px', textAlign: 'center' }}>
                    <small style={{ color: '#718096' }}>Col {idx + 1}</small>
                    <div style={{ display: 'flex', gap: '3px', justifyContent: 'center', marginTop: '4px' }}>
                      {col.map(n => <span key={n} className="numero-ball small">{n}</span>)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {dettaglio.risultati_ruote && dettaglio.risultati_ruote.length > 0 && (
            <div style={{ marginBottom: '15px' }}>
              <strong>Risultati Verifica:</strong>
              {dettaglio.risultati_ruote.map((r, idx) => (
                <div key={idx} style={{ padding: '10px', background: r.vincita_ruota > 0 ? '#f0fff4' : '#f7fafc', borderRadius: '8px', marginTop: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span className="ruota-badge">{r.ruota_nome}</span>
                    <span>Estratti:</span>
                    {r.numeri_estratti.map(n => <span key={n} className="numero-ball small">{n}</span>)}
                  </div>
                  {r.colonne_vincenti.length > 0 ? (
                    <div style={{ color: '#22543d' }}>
                      {r.colonne_vincenti.map((cv, i) => (
                        <div key={i}>
                          Colonna {cv.colonna_idx}: {cv.tipo.toUpperCase()} - Indovinati: {cv.indovinati.join(', ')} - EUR {cv.importo_vinto.toFixed(2)}
                        </div>
                      ))}
                      <div style={{ fontWeight: 'bold', marginTop: '5px' }}>Totale ruota: EUR {r.vincita_ruota.toFixed(2)}</div>
                    </div>
                  ) : (
                    <div style={{ color: '#718096' }}>Nessuna vincita su questa ruota</div>
                  )}
                </div>
              ))}
              <div style={{ marginTop: '15px', padding: '10px', background: dettaglio.vincita_totale > 0 ? '#c6f6d5' : '#fed7d7', borderRadius: '8px', fontWeight: 'bold', fontSize: '1.1rem' }}>
                TOTALE: EUR {dettaglio.vincita_totale.toFixed(2)}
              </div>
            </div>
          )}
        </div>
      )}

      {activeTab === 'nuovo' && (
        <>
          <div className="card" style={{ marginBottom: '20px' }}>
            <h3 className="card-title">Genera Sistema Ridotto</h3>
            <div className="form-group">
              <label className="form-label">I tuoi numeri (da 7 a 10)</label>
              <input type="text" className="form-input" value={numeriInput} onChange={(e) => { setNumeriInput(e.target.value); setSistemaGenerato(null); setCostoCalcolato(null); }} placeholder="Es: 7, 14, 23, 45, 56, 67, 89" />
              <small style={{ color: '#718096' }}>Numeri: {parseNumeri().length} {parseNumeri().length >= 7 && parseNumeri().length <= 10 ? 'OK' : ''}</small>
            </div>
            <div className="form-group">
              <label className="form-label">Garanzia</label>
              <select className="form-select" value={garanzia} onChange={(e) => { setGaranzia(e.target.value); setSistemaGenerato(null); setCostoCalcolato(null); }}>
                <option value="terno_se_4">Terno garantito se escono 4 numeri</option>
                <option value="ambo_se_3">Ambo garantito se escono 3 numeri</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Ruote <button type="button" onClick={selectAllRuote} style={{ marginLeft: '10px', fontSize: '0.8rem', background: 'none', border: 'none', color: '#2c5282', cursor: 'pointer' }}>{selectedRuote.length === ruote.length ? '(Deseleziona)' : '(Tutte)'}</button></label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {ruote.map(r => (
                  <span key={r.id} className="ruota-badge" style={{ cursor: 'pointer', background: selectedRuote.includes(r.id) ? '#2c5282' : '#e2e8f0', color: selectedRuote.includes(r.id) ? 'white' : '#4a5568' }} onClick={() => toggleRuota(r.id)}>{r.nome}</span>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
              <div className="form-group" style={{ flex: 1, minWidth: '150px' }}>
                <label className="form-label">EUR per colonna</label>
                <input type="number" className="form-input" value={importoPerColonna} onChange={(e) => { setImportoPerColonna(parseFloat(e.target.value) || 1); setCostoCalcolato(null); }} min="0.5" step="0.5" />
              </div>
              <div className="form-group" style={{ flex: 1, minWidth: '150px' }}>
                <label className="form-label">Data</label>
                <input type="date" className="form-input" value={dataGiocata} onChange={(e) => setDataGiocata(e.target.value)} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
              <button className="btn btn-secondary" onClick={handleGeneraSistema}>Genera</button>
              <button className="btn btn-primary" onClick={handleCalcolaCosto} disabled={parseNumeri().length < 7 || selectedRuote.length === 0}>Calcola Costo</button>
            </div>
          </div>

          {sistemaGenerato && (
            <div className="card" style={{ marginBottom: '20px', border: '2px solid #48bb78' }}>
              <h3 className="card-title" style={{ color: '#22543d' }}>Sistema Generato</h3>
              <p><strong>Garanzia:</strong> {sistemaGenerato.garanzia_descrizione}</p>
              <p><strong>Colonne:</strong> {sistemaGenerato.n_colonne} (invece di {sistemaGenerato.n_colonne_integrali}) - <span style={{ color: '#22543d' }}>Risparmio {sistemaGenerato.risparmio_percentuale}%</span></p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: '8px', marginTop: '10px' }}>
                {sistemaGenerato.colonne.map((col, idx) => (
                  <div key={idx} style={{ padding: '8px', background: '#f7fafc', borderRadius: '6px', textAlign: 'center' }}>
                    <small style={{ color: '#718096' }}>Col {idx + 1}</small>
                    <div style={{ display: 'flex', gap: '3px', justifyContent: 'center', marginTop: '4px' }}>
                      {col.map(n => <span key={n} className="numero-ball small">{n}</span>)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {costoCalcolato && (
            <div className="card" style={{ marginBottom: '20px', background: '#f0fff4' }}>
              <h3 className="card-title">Riepilogo</h3>
              <p>{costoCalcolato.n_colonne} colonne x {costoCalcolato.n_ruote} ruote x EUR {costoCalcolato.importo_per_colonna}</p>
              <p style={{ fontSize: '1.5rem', color: '#2c5282' }}><strong>Totale: EUR {costoCalcolato.costo_totale}</strong></p>
              {costoCalcolato.warning && <p style={{ color: '#c53030' }}>{costoCalcolato.warning}</p>}
              <button className="btn btn-success" onClick={handleGiocaSistema} style={{ marginTop: '10px' }}>Registra Sistema</button>
            </div>
          )}
        </>
      )}

      {activeTab === 'salvati' && (
        <div className="card">
          <h3 className="card-title">I miei Sistemi</h3>
          {sistemiSalvati.length === 0 ? (
            <p style={{ color: '#718096', textAlign: 'center', padding: '20px' }}>Nessun sistema salvato.</p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Nome</th>
                  <th>Numeri</th>
                  <th>Ruote</th>
                  <th>Costo</th>
                  <th>Stato</th>
                  <th>Vincita</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {sistemiSalvati.map(s => (
                  <tr key={s.id}>
                    <td>{new Date(s.data_giocata).toLocaleDateString('it-IT')}</td>
                    <td>{s.nome}</td>
                    <td>{s.numeri.slice(0, 4).map(n => <span key={n} className="numero-ball small">{n}</span>)}{s.numeri.length > 4 && <span style={{ color: '#718096' }}> +{s.numeri.length - 4}</span>}</td>
                    <td>{s.ruote_nomi.slice(0, 2).join(', ')}{s.ruote_nomi.length > 2 && '...'}</td>
                    <td>EUR {s.costo_totale.toFixed(2)}</td>
                    <td><span className="ruota-badge" style={{ background: getStatoColor(s.stato).bg, color: getStatoColor(s.stato).color }}>{s.stato.toUpperCase()}</span></td>
                    <td>{s.vincita_totale > 0 ? <span style={{ color: '#22543d', fontWeight: 'bold' }}>EUR {s.vincita_totale.toFixed(2)}</span> : '-'}</td>
                    <td>
                      <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap' }}>
                        <button className="btn btn-primary" style={{ padding: '3px 8px', fontSize: '0.75rem' }} onClick={() => handleDettaglio(s.id)}>Dettaglio</button>
                        {s.stato === 'attivo' && <button className="btn btn-success" style={{ padding: '3px 8px', fontSize: '0.75rem' }} onClick={() => handleVerifica(s.id)}>Verifica</button>}
                        <button className="btn btn-danger" style={{ padding: '3px 8px', fontSize: '0.75rem' }} onClick={() => handleDelete(s.id)}>Elimina</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {activeTab === 'info' && (
        <div className="card">
          <h3 className="card-title">Sistemi Disponibili</h3>
          <table className="table">
            <thead>
              <tr><th>Numeri</th><th>Garanzia</th><th>Colonne</th><th>Integrale</th><th>Risparmio</th></tr>
            </thead>
            <tbody>
              {sistemiDisponibili.map((s, idx) => (
                <tr key={idx} style={{ background: s.garanzia === 'terno_se_4' ? '#f0fff4' : '#fef3c7' }}>
                  <td><strong>{s.n_numeri}</strong></td>
                  <td>{s.garanzia_descrizione}</td>
                  <td><strong>{s.n_colonne}</strong></td>
                  <td style={{ color: '#718096' }}>{s.n_integrali}</td>
                  <td style={{ color: '#22543d', fontWeight: 'bold' }}>{s.risparmio}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SistemiRidotti;
